module.exports = __webpack_public_path__ + "img/2.13c15c00.jpg";